// src/components/pages/message/timecapsule/VideoRecorderModal.js
import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import { ReactMediaRecorder } from "react-media-recorder";

const VideoPreview = ({ previewStream, mediaBlobUrl }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      if (previewStream && typeof previewStream.getTracks === "function") {
        videoRef.current.srcObject = previewStream;
      } else {
        videoRef.current.src = mediaBlobUrl;
      }
    }
  }, [previewStream, mediaBlobUrl]);

  return (
    <video
      ref={videoRef}
      controls
      autoPlay
      muted
      playsInline
      style={{ width: "100%" }}
    />
  );
};

const VideoRecorderModal = ({ open, onClose, onCapture }) => {
  const [facingMode, setFacingMode] = useState("environment");

  const toggleFacingMode = () => {
    setFacingMode((prev) => (prev === "environment" ? "user" : "environment"));
  };

  // Show switch button only on mobile.
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          p: 2,
          width: "90%",
          maxWidth: 500, // Constrain width on small screens
          borderRadius: 1,
        }}
      >
        <ReactMediaRecorder
          video
          videoConstraints={{ facingMode }}
          onStop={(blobUrl, blob) => {
            onCapture(blobUrl);
          }}
          render={({
            status,
            startRecording,
            stopRecording,
            mediaBlobUrl,
            previewStream,
          }) => (
            <Box>
              <p>{status}</p>
              <VideoPreview
                previewStream={previewStream}
                mediaBlobUrl={mediaBlobUrl}
              />
              <Box
                sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}
              >
                {isMobile && (
                  <Button
                    onClick={toggleFacingMode}
                    sx={(theme) => ({
                      backgroundColor: theme.colors.white,
                      color: theme.colors.blue,
                      borderRadius: "50px",
                      border: `1px solid ${theme.colors.blue}`,
                      padding: "10px 20px",
                      marginBottom: "4px",
                      fontSize: "1rem",
                      textTransform: "none",
                      boxShadow: "none",
                      "&:hover": {
                        boxShadow: "none",
                      },
                    })}
                  >
                    Switch Camera
                  </Button>
                )}
                {/* Single toggle button for recording */}
                <Button
                  onClick={() => {
                    if (status === "recording") {
                      stopRecording();
                    } else {
                      startRecording();
                    }
                  }}
                  sx={(theme) => ({
                    backgroundColor: theme.colors.white,
                    color: theme.colors.blue,
                    borderRadius: "50px",
                    border: `1px solid ${theme.colors.blue}`,
                    padding: "10px 20px",
                    marginBottom: "4px",
                    fontSize: "1rem",
                    textTransform: "none",
                    boxShadow: "none",
                    "&:hover": {
                      boxShadow: "none",
                    },
                  })}
                >
                  {status === "recording"
                    ? "Stop Recording"
                    : "Start Recording"}
                </Button>
                <Button
                  variant="text"
                  onClick={onClose}
                  sx={(theme) => ({
                    backgroundColor: theme.colors.white,
                    color: "black",
                    textDecoration: "underline",
                    border: "0px",
                    borderRadius: "50px",
                    padding: "10px 20px",
                    marginBottom: "10px",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    textTransform: "none",
                    boxShadow: "none",
                    "&:hover": {
                      boxShadow: "none",
                    },
                  })}
                >
                  Cancel
                </Button>
              </Box>
            </Box>
          )}
        />
      </Box>
    </Modal>
  );
};

export default VideoRecorderModal;
